import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  Input,
  Text,
  Textarea,
} from "@chakra-ui/react";
import React from "react";
import Navbar from "../../components/Navbar";
import Banner from "../../components/Banner";
import { Form, Formik } from "formik";
import { Send } from "react-feather";
import Footer from "../../components/Footer";
type ContactProps = {};
const Contact: React.FC<ContactProps> = () => {
  const INITIAL_VALUES = {};
  const handleSubmit = () => {};
  return (
    <>
      <Flex w="100%" h="90vh" direction="column">
        <Navbar />
        <Banner />
      </Flex>
      <Heading align="center" fontFamily="Poppins, sans-serif">
        Get In Touch
      </Heading>
      <Flex w="100%" h="100%" p={20} justify="space-around">
        <Flex
          w="50%"
          h="50%"
          p={20}
          borderRadius="10px"
          justify="space-between"
          // direction="column"
          bg="#667aff"
        >
          <Formik initialValues={INITIAL_VALUES} onSubmit={handleSubmit}>
            <Form style={{ width: "100%", height: "100%" }}>
              <Flex justify="space-between" w="100%">
                <Box w="100%">
                  <FormLabel htmlFor="Name" color="#ffffff">
                    Name
                  </FormLabel>
                  <Input name="name" w="80%" bg="white" />
                </Box>
                <Box w="inherit">
                  <FormLabel htmlFor="email" color="#ffffff">
                    e-mail
                  </FormLabel>
                  <Input name="email" w="100%" bg="white" />
                </Box>
              </Flex>
              <br />
              <br />
              <Box w="50%" h="50%">
                <FormLabel htmlFor="message" color="#ffffff">
                  Message
                </FormLabel>
                <Textarea name="message" h="80%" bg="white" />
              </Box>
              <br />
              <Button type="submit" bgColor="#fffff">
                <Send /> Send
              </Button>
            </Form>
          </Formik>
        </Flex>
        <Flex
          direction="column"
          fontSize="lg"
          justify="space-around"
          boxSize="lg"
          h="90%"
        >
          <br />
          <br />
          <Text fontSize="lg" justify="center">
            We have assisted many companies with their unique challenges. We can
            do the same for you. Get in touch with us now to see how we can find
            synergies between what we are good at and what you need. Take your
            business to the next level.
          </Text>
          <br />
          <br />
          <br />
          <Text fontSize="lg" align="left">
            HRBEE PTY (LTD)
            <br />
            Constantia Square Office Park,
            <br /> 526 16th Road,
            <br />
            Midrand Gauteng,
            <br />
            1685 
            {/* P: (071) 678 1609 */}
          </Text>
        </Flex>
      </Flex>
      <Footer />
    </>
  );
};
export default Contact;
